export const UserRole = {
  Admin: 1,
  Manager: 2,
  Professor: 3,
  Student: 4
}



// WEBPACK FOOTER //
// ./src/enum/index.js